module.exports = __webpack_public_path__ + "static/media/SpeechBubble.5e6bb7cb.svg";